import { Component, Input, OnChanges } from '@angular/core';
import { HeaderDropdownService } from './header-dropdown.service';
import { Config } from '../universal-config';
import {setTheme} from "../visual/visual.actions";
import {Store} from "@ngrx/store";
import {IAppState} from "../app.state";
import {NoteService} from "../share/note/note.service";
import { isB2BOrgPredicate } from '../../model/organization.model';

@Component({
  selector: 'nns-profile-more',
  template: `
  <div class="nns-modal-more-signed-in" flex layout="column"
    *ngIf="profile; else notLogged"
  >
    <div class="nns-modal-more-signed-account" flex="none" layout="row"
      layout-align="start center"
    >
      <div class="nns-modal-more-signed-logo-small" flex="none">
        <img *ngIf="!profile.avatarUrl" src="./dist/assets/fusebase-icon.svg" alt="fusebase icon" />
        <img *ngIf="profile.avatarUrl" src="{{profile.avatarUrl}}" />
      </div>
      <div class="nns-modal-more-signed-account-text" flex layout="column" [title]="profile.email">
        <div class="nns-modal-more-signed-account-title" flex="none">Account</div>
        <div class="nns-modal-more-signed-account-name" flex="noshrink">{{profile.email}}</div>
      </div>
    </div>

    <a class="nns-modal-signed-link nns-link-open-note" [href]="noteUrl" target="_blank" *ngIf="note && note.type && isShowOpenNote" title="Open {{ note.type === 'note' ? 'page' : note.type }} in web-client"
      flex="noshrink" layout="row" layout-align="start center"
    >
      <nns-icon icon="redo" flex="none"></nns-icon>
      <span flex="none">
        Open {{ note.type === 'note' ? 'page' : note.type }} in web-client
      </span>
    </a>

    <a class="nns-modal-signed-link" target="_blank" *ngIf="note && note.type" title="Change theme"
      flex="noshrink" layout="row" layout-align="start center" (click)="changeTheme()"
    >
      <nns-icon *ngIf="visual.theme === 'day'" icon="day-mode-grey" flex="none"></nns-icon>
      <nns-icon *ngIf="visual.theme === 'night'" icon="night-mode-grey" flex="none"></nns-icon>
      <span flex="none" *ngIf="visual.theme === 'day'">
        Dark theme
      </span>
      <span flex="none" *ngIf="visual.theme === 'night'">
        Light theme
      </span>
    </a>

     <a class="nns-modal-signed-link nns-link-branding" *ngIf="brandingUrl" [href]="brandingUrl" target="_blank" title="Branding"
      flex="noshrink" layout="row" layout-align="start center"
    >
      <nns-icon icon="branding" flex="none"></nns-icon>
      <span flex="none">
        Branding
      </span>
    </a>

    <a class="nns-modal-signed-link nns-link-my-notes" [href]="nimbusNoteUrl" title="My pages"
      flex="noshrink" layout="row" layout-align="start center"
    >
      <nns-icon icon="note" flex="none"></nns-icon>
      <span flex="none">
        My pages
      </span>
    </a>

    <span class="nns-modal-signed-link" clickLogout title="Logout" flex="noshrink"
      layout="row" layout-align="start center"
    >
      <nns-icon icon="exit" flex="none"></nns-icon>
      <span flex="none">
        Logout
      </span>
    </span>

  </div>

  <ng-template #notLogged>
    <div class="nns-modal-more-signed-out" flex layout="column">
      <div class="nns-modal-more-signed-logo" flex="none" layout="row"
        layout-align="center center"
      >
        <nns-icon icon="nimbus-note"></nns-icon>
      </div>
      <div class="nns-modal-more-signed-text">
        Never forget something important for you!
      </div>
      <div class="nns-modal-signed-action">
        <nns-button text="Sign In" clickLogin (click)="close()"></nns-button>
      </div>
    </div>
  </ng-template>
  `,
  styles: [`
    :host {
      background: #FFFFFF;
      border: 1px solid #E9EEF0;
      border-radius: 4px;
      box-sizing:border-box;
      width:248px;
      font-size:12px;
      display:block;
      padding:8px;
      box-shadow: 4px 4px 38px rgba(167, 194, 198, 0.35);
    }
    .nns-modal-more-signed-logo {padding:0 0 10px 0;}
    .nns-modal-more-signed-text {
      text-align:center;
      padding:0 0 16px 0;
      color:rgba(0,0,0,0.60);
    }
    .nns-modal-signed-action nns-button {display:block; width:100%;}

    .nns-modal-more-signed-out{
      padding:0 0 16px 0;
    }

    .nns-modal-more-signed-account {
      padding:0 16px 8px 16px;
      border-bottom: 1px solid #E9EEF0;
    }
    .nns-modal-more-signed-logo-small nns-icon {display:block;}
    .nns-modal-more-signed-logo-small {width: 16px; height: 16px;}
    .nns-modal-more-signed-logo-small img{
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }
    .nns-modal-more-signed-account-text {padding:0 0 0 16px;}
    .nns-modal-more-signed-account-name {
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
      font-size:14px;
      max-width: 100%;
    }

    .nns-modal-signed-link {
      padding: 9px 16px;
      color: #1F1F1F;
      font-size: 13px;
      cursor: pointer;
      margin-top: 8px;
    }
    .nns-modal-signed-link nns-icon {
      margin-right: 14px;
    }
    .nns-modal-more-signed-logo-small nns-icon, .nns-modal-signed-link nns-icon {
      min-width: 16px;
      min-height: 16px;
      width: 16px;
      height: 16px;
    }
    .nns-modal-signed-link:hover {background:rgba(236,239,241,0.28);}

    .nns-modal-more-products {}
    .nns-modal-more-products-title {
      font-weight:bold;
      font-size:16px;
      padding:0 0 10px 0;
    }
    .nns-modal-more-products-item {padding:0 0 20px 0;}
    .nns-modal-more-products-item a,
    .nns-modal-more-products-item nns-icon {display:block;}



    @media only screen and (max-width: 768px) {
      .nns-link-my-notes, .nns-link-open-note, .nns-link-branding{
        display: none;
      }
    }
  `, `
    :host-context(.nns-theme-night) {
      background: #292E32;
      border-color: #161A1E;
      box-shadow: 4px 4px 38px rgba(19, 30, 32, 0.66);
    }
    :host-context(.nns-theme-night) .nns-modal-more-signed-text,
    :host-context(.nns-theme-night) .nns-modal-more-signed-account-title {
      color: rgba(255,255,255,0.60);
    }
    :host-context(.nns-theme-night) .nns-modal-more-signed-account {
      border-bottom-color: #161A1E;
    }
    :host-context(.nns-theme-night) .nns-modal-more-signed-out,
    :host-context(.nns-theme-night) .nns-modal-more-signed-in {
      border-color:rgba(0,0,0, 0.12);
    }
    :host-context(.nns-theme-night) .nns-modal-signed-link {
      color: #fff;
    }
    :host-context(.nns-theme-night) .nns-modal-signed-link:hover {
      background:rgba(181,181,181,0.10);
      color:#fff;
    }
  `]
})
export class ProfileMoreComponent implements OnChanges{
  @Input() profile;
  @Input() note;
  @Input() share;
  @Input() shareOrganization;
  @Input() visual;
  @Input() workspaces;
  nimbusNoteUrl;
  noteUrl;
  nimbusTeamsUrl;
  brandingUrl;
  isShowOpenNote: boolean;


  constructor(
    public headerDropdownService: HeaderDropdownService,
    public _config: Config,
    public _store: Store<IAppState>,
    public _noteService: NoteService,
  ) {
    this.nimbusNoteUrl = this._config.get('NIMBUS_NOTE_URL');
    this.nimbusTeamsUrl = this._config.get('NIMBUS_TEAMS_URL');
  }

  close() {
    this.headerDropdownService.close();
  }

  ngOnChanges(changes) {
    if(this.note && this.share && this.share.instance) {
      this.setNoteUrl();
    }
    if((changes.workspaces || changes.share) && this.workspaces.length) {
      this.isShowOpenNote = this.workspaces.some((workspace) => workspace.globalId === this.share.instance.workspaceId)
    }
  }

  setNoteUrl() {
    this.noteUrl = this._noteService.getNodeUrl(this.share.instance.org, this.note.workspaceId, this.note.globalId, this.note.type);
    if(this.shareOrganization
      && isB2BOrgPredicate()(this.shareOrganization)
      && this.shareOrganization.userRole
      && (this.shareOrganization.userRole.role == 'owner' || this.shareOrganization.userRole.role == 'manager')) {
        this.setBrandingUrl();
      }
  }

  setBrandingUrl() {
    this.brandingUrl = `${this.nimbusTeamsUrl}/org/${this.shareOrganization.globalId}/ws/${this.share.instance.workspaceId}?editTitle=false&openBranding=true`;
  }

  changeTheme() {
    if (this.visual.theme === 'day') {
      this._store.dispatch(setTheme('night'));
    } else {
      this._store.dispatch(setTheme('day'));
    }
  }
}
